import React from "react";
import useTranslations from "@/i18n/useTranslations";

const Disclaimer = ({
  text,
  overrideStyle = "",
}: {
  text?: string;
  overrideStyle?: string;
}) => {
  const t = useTranslations("Common");
  const resolvedText = text ?? t("disclaimer2u");
  return (
    <div>
      {overrideStyle ? (
        <span className={overrideStyle}>{resolvedText}</span>
      ) : (
        <p className="py-8 mb-0 text-[1.375rem] text-center font-bold text-brand">
          {resolvedText}
        </p>
      )}
    </div>
  );
};

export default Disclaimer;
